'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _languageHandler = require('../../../languageHandler');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _Validation = require('./Validation');

var _Validation2 = _interopRequireDefault(_Validation);

var _MatrixClientPeg = require('../../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2019 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
var RoomAliasField = function (_React$PureComponent) {
    (0, _inherits3.default)(RoomAliasField, _React$PureComponent);

    function RoomAliasField(props) {
        (0, _classCallCheck3.default)(this, RoomAliasField);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RoomAliasField.__proto__ || (0, _getPrototypeOf2.default)(RoomAliasField)).call(this, props));

        _this._onChange = function (ev) {
            if (_this.props.onChange) {
                _this.props.onChange(_this._asFullAlias(ev.target.value));
            }
        };

        _this._onValidate = async function (fieldState) {
            var result = await _this._validationRules(fieldState);
            _this.setState({ isValid: result.valid });
            return result;
        };

        _this._validationRules = (0, _Validation2.default)({
            rules: [{
                key: "safeLocalpart",
                test: async function test(_ref) {
                    var value = _ref.value;

                    if (!value) {
                        return true;
                    }
                    var fullAlias = _this._asFullAlias(value);
                    // XXX: FIXME https://github.com/matrix-org/matrix-doc/issues/668
                    return !value.includes("#") && !value.includes(":") && !value.includes(",") && encodeURI(fullAlias) === fullAlias;
                },
                invalid: function invalid() {
                    return (0, _languageHandler._t)("Some characters not allowed");
                }
            }, {
                key: "required",
                test: async function test(_ref2) {
                    var value = _ref2.value,
                        allowEmpty = _ref2.allowEmpty;
                    return allowEmpty || !!value;
                },
                invalid: function invalid() {
                    return (0, _languageHandler._t)("Please provide a room alias");
                }
            }, {
                key: "taken",
                test: async function test(_ref3) {
                    var value = _ref3.value;

                    if (!value) {
                        return true;
                    }
                    var client = _MatrixClientPeg2.default.get();
                    try {
                        await client.getRoomIdForAlias(_this._asFullAlias(value));
                        // we got a room id, so the alias is taken
                        return false;
                    } catch (err) {
                        // any server error code will do,
                        // either it M_NOT_FOUND or the alias is invalid somehow,
                        // in which case we don't want to show the invalid message
                        return !!err.errcode;
                    }
                },
                valid: function valid() {
                    return (0, _languageHandler._t)("This alias is available to use");
                },
                invalid: function invalid() {
                    return (0, _languageHandler._t)("This alias is already in use");
                }
            }]
        });

        _this.state = { isValid: true };
        return _this;
    }

    (0, _createClass3.default)(RoomAliasField, [{
        key: '_asFullAlias',
        value: function _asFullAlias(localpart) {
            return '#' + localpart + ':' + this.props.domain;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var Field = _index2.default.getComponent('views.elements.Field');
            var poundSign = _react2.default.createElement(
                'span',
                null,
                '#'
            );
            var aliasPostfix = ":" + this.props.domain;
            var domain = _react2.default.createElement(
                'span',
                { title: aliasPostfix },
                aliasPostfix
            );
            var maxlength = 255 - this.props.domain.length - 2; // 2 for # and :
            return _react2.default.createElement(Field, {
                label: (0, _languageHandler._t)("Room alias"),
                className: 'mx_RoomAliasField',
                prefix: poundSign,
                postfix: domain,
                id: this.props.id,
                ref: function ref(_ref4) {
                    return _this2._fieldRef = _ref4;
                },
                onValidate: this._onValidate,
                placeholder: (0, _languageHandler._t)("e.g. my-room"),
                onChange: this._onChange,
                maxLength: maxlength });
        }
    }, {
        key: 'validate',
        value: function validate(options) {
            return this._fieldRef.validate(options);
        }
    }, {
        key: 'focus',
        value: function focus() {
            this._fieldRef.focus();
        }
    }, {
        key: 'isValid',
        get: function get() {
            return this.state.isValid;
        }
    }]);
    return RoomAliasField;
}(_react2.default.PureComponent);

RoomAliasField.propTypes = {
    id: _propTypes2.default.string.isRequired,
    domain: _propTypes2.default.string.isRequired,
    onChange: _propTypes2.default.func
};
exports.default = RoomAliasField;
module.exports = exports['default'];
//# sourceMappingURL=RoomAliasField.js.map